import { useCallback, useEffect, useState } from 'preact/hooks';

import type { StateUpdater } from 'preact/hooks';

function updateSession<T>(key: string, prev: T | null, update: StateUpdater<T>) {
  const nextValue = typeof update === 'function' ? (update as (prev: T | null) => T)(prev) : update;
  sessionStorage.setItem(key, JSON.stringify(nextValue));
  return nextValue;
}

export function useSessionStore<T>(key: string, initial: T) {
  const [state, setState] = useState(() => {
    const saved = sessionStorage.getItem(key);
    if (!saved) {
      return initial;
    }
    return JSON.parse(saved) as T;
  });
  const stateSetter = useCallback(
    (update: StateUpdater<T>) =>
      setState((prev) => {
        return updateSession(key, prev, update);
      }),
    []
  );

  const sessionOnlySetter = useCallback((update: StateUpdater<T>) => {
    updateSession(key, sessionStorage.getItem(key) as T, update);
  }, []);
  return [state, stateSetter, sessionOnlySetter] as const;
}

const MOBILE_WIDTH_THRESHOLD = 768;

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= MOBILE_WIDTH_THRESHOLD);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= MOBILE_WIDTH_THRESHOLD);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile;
}
